import api from 'Application/api/api';

const updateProjectTimeline = (projectId, data, cancelToken = null) =>
    api.post(`project-manager/projects/${projectId}/timeline`, data, {
        cancelToken,
    });

export default updateProjectTimeline;
